module.exports = __webpack_public_path__ + "static/img/Li-Yuan.jpg";